<template>
    <div class="ticketDetailsBox">
        <div class="scroll">
            <div class="imgBox">
                <img :src="userData.wxHeadImgUrl" alt="图片">
            </div>
            <div class="nick">{{userData.wxNickName}}</div>

            <div  class="qrcode"></div >
            <div class='zText'>使用时请将此页面出示给工作人员</div>

            <md-field>
                <md-input-item
                        title="手机号"
                        type="phone"
                        v-model="mPhone"
                        placeholder="转赠人手机号"
                ></md-input-item>
                <!--<md-input-item-->
                        <!--title="验证码"-->
                        <!--v-model="securityCode"-->
                        <!--type="digit"-->
                <!--&gt;-->
                    <!--<div class="operatorNum" v-if="securityState" slot="right" >{{num}}s</div>-->
                    <!--<div class="input-operator" @click="securityCodeFn" v-else slot="right" >获取验证码</div>-->
                <!--</md-input-item>-->
            </md-field>
            <div class="btn" @click="exchange">卡券转赠</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ticketDetails",
        mounted() {
            this.itemData = JSON.parse(this.$route.query.itemData)
            this.userData = JSON.parse(localStorage.getItem("userData"))
            document.title = "我的卡券"
            // console.log(this.itemData)

            setTimeout(()=>{
                var width = 160;
                var margin = 2;
                var qr = window.qrcode(4, 'H');
                qr.addData(this.userData.cardNo);
                qr.make(); //3
                var moduleCount = qr.getModuleCount()
                var cell = (width - margin * 2) / moduleCount;
                document.querySelector('.qrcode').innerHTML = qr.createImgTag(cell, margin);
            },120)
        },
        data(){
            return {
                itemData:'',
                userData:'',
                securityState:false, //换取验证码按钮状态
                num:60,
                wei:6, //验证码位数
                securityCode:"", //验证码
                mPhone:'', //手机号
            }
        },
        methods:{
            securityCodeFn(){ //获取验证码
                this.securityState = true
                this.stop = setInterval(()=>{
                    if(this.num == 0){
                        clearInterval(this.stop)
                        this.securityState = false
                        this.num = 60
                    }else{
                        this.num--
                    }
                },1000)

                let mes = new URLSearchParams()
                mes.append('phone', this.userData.phone) //手机
                mes.append('id', this.userData.wxOpenId) //用户id
                mes.append('num', this.wei) //验证码位数
                this.$http.post('/system/base/securityCode/message', mes).then(()=>{ //获取验证码

                })
            },
            exchange() {//转赠
                let {mPhone, userData} = this
                if(!(/^1[34578]\d{9}$/.test(mPhone))){
                    this.UI.Toast.failed("手机号格式错误")
                    return
                }else if(mPhone == userData.phone){
                    this.UI.Toast.failed("手机号码不能和当前用户号码重复")
                    return
                }
                let dt = new URLSearchParams()
                dt.append('phone', mPhone)
                dt.append('meCardNo', userData.cardAccount) //cardAccount
                dt.append('couponsNo', this.itemData.cardNo) //
                this.$http.post('/sangto-wrm/vip/coupons/givingCoupons', dt).then(({data}) => {

                    this.UI.Toast.info(data.message)
                    this.$router.push('/appMain')
                })
            }

        }
    }
</script>

<style scoped lang="scss">
.ticketDetailsBox{
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fff;
    overflow-y: auto;
    overflow-x: hidden;
    .scroll{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 30px;
    }
    .imgBox{
        margin-top: 16px;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        overflow: hidden;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .nick{
        font-size: 14px;
        margin-top: 6px;
    }
    .qrcode{
        margin-top: 26px;
    }
    .zText{
        margin-top: 4px;
        font-size: 12px;
    }
    .btn{
        width: 88%;
        height: 45px;
        line-height: 45px;
        background-color: #4c9ee3;
        color: #fff;
        margin: 30px auto 0 auto;
        text-align: center;
        border-radius: 5px;
        letter-spacing: 1px;
    }
    .operatorNum{
        margin-right: 11px;
        width: 60px;
        height: 34px;
        text-align: center;
        line-height: 34px;
        color: #ea5a59;
        border-radius: 4px;
        font-size: 14px;
    }
    .input-operator{
        margin-right: 1px;
        width: 100px;
        height: 34px;
        text-align: center;
        line-height: 34px;
        color: #26a2fc;
        border-radius: 4px;
        font-size: 14px;
    }
}
</style>
